import { render, staticRenderFns } from "./weblink-file-svg.vue?vue&type=template&id=47750def&scoped=true&"
var script = {}
import style0 from "./weblink-file-svg.vue?vue&type=style&index=0&id=47750def&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47750def",
  null
  
)

export default component.exports